import { ParticipantEvent } from './ParticipantEvent';
import { Study } from './Study';
import { StudyTemplate } from './StudyTemplate';
import { User } from './User';

/** Kept by the server and shown as-is in the portal. */
export enum StudyParticipantStatus {
  NotStarted = 'Not Started',
  NoQualificationStatus = 'No Qualification Status',
  IncompleteQualification = 'Incomplete Qualification',
  Qualified = 'Qualified',
  NotQualified = 'Not Qualified',
  Consented = 'Consented',
  Enrolled = 'Enrolled',
  Completed = 'Completed',
  ClosedOut = 'Closed Out',
  Withdrawn = 'Withdrawn',
  ScreenFailed = 'Screen Failed'
}

export interface StudyParticipant {
  id: number;
  status: StudyParticipantStatus;
  studyId: number;
  userId: number;
  user: User;
  study?: Study;
  /**
   * Used defined start date
   */
  intendedStartDate: string;
  /**
   * Actual Start Date
   */
  startDate: Date | null;
  /**
   * Populated if participant completed a "Sponsored" study.
   */
  actualEndDate: Date | null;
  /**
   * Generated when a study is started based on the study duration and first study template applied.
   */
  projectedEndDate: Date | null;
  /**
   * Populated if participant screen-failed from a "Sponsored" study.
   */
  screenFailedDate: Date | null;
  /**
   * Populated if participant withdraws from a "Sponsored" study.
   */
  withdrawnDate: Date | null;
  /**
   * Study length in days.
   */
  studyLength: number;
  preferredNotificationTime: string;
  participantEvents: ParticipantEvent[];
  created: Date;
  paused: Date;
  participantAppliedStudyTemplates?: ParticipantAppliedStudyTemplate[];
  qualified: Date | null;
  disqualified: Date | null;
  inviteSent: Date | null;
  deleted?: Date | null;
}

export interface ParticipantAppliedStudyTemplate {
  id: number;
  startDate: Date;
  studyTemplate: StudyTemplate;
}
